import { forwardRef, useState } from "react";
import PropTypes from "prop-types";
import { Button } from "components/ui_new/index";
import useTranslate from "hooks/use-translate-language";
import { DOCUMENT_UPLOAD_ACCEPT, isAllowedUploadFile } from "utils/files";
import NotificationManager from "utils/notifications";
import "./documents.scss";

const FileUploader = forwardRef(({ onChange, onRemove }, fileRef) => {
  const translate = useTranslate();
  const handleClick = () => {
    fileRef.current.click();
  };
  const [selectedFile, setSelectedFile] = useState();
  const handleChange = event => {
    const file = event.target.files[0];
    // S3DEV2-7865: the accept list is only a hint, so tell the patient right away.
    if (file && !isAllowedUploadFile(file.name)) {
      event.target.value = "";
      NotificationManager.error("fileTypeNotSupported");
      return;
    }
    setSelectedFile(file);
    if (typeof onChange === "function") {
      onChange(event);
    }
  };
  return (
    <>
      {selectedFile ? (
        <div style={{ margin: 5, padding: 5 }}>
          <span>{selectedFile.name}</span>
          <span
            onClick={() => {
              setSelectedFile(undefined);
              fileRef.current.value = "";
              if (typeof onRemove === "function") onRemove(undefined);
            }}
            style={{ color: "red" }}
          >
            {translate("remove")}
          </span>
        </div>
      ) : (
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleClick}
          className="upload-file-button"
        >
          {translate("uploadAFile")}
        </Button>
      )}
      <input
        type="file"
        accept={DOCUMENT_UPLOAD_ACCEPT}
        ref={fileRef}
        onChange={handleChange}
        style={{ display: "none" }}
        aria-label={translate("uploadAFile")}
      />
    </>
  );
});

FileUploader.propTypes = { onChange: PropTypes.func, onRemove: PropTypes.func };

export default FileUploader;
